import { defineStore } from 'pinia';
import * as Sentry from '@sentry/vue';

export const useUserStore = defineStore('user', {
  state: () => ({
    username: '',
    empId: '',
    empName: '',
    taskCount: 0
  }),
  actions: {
    storeUserData(user) {
      // 將用戶數據存儲在本地存儲中
      this.username = user.username;
      this.empId = user.empId;
      this.empName = user.empName;

      // 設置 Sentry 用戶資訊和標籤
      Sentry.setUser({
        id: user.empId,
        username: user.username,
        empName: user.empName
      });

      Sentry.setTag('empId', user.empId);
      Sentry.setTag('empName', user.empName);

      // 添加用戶登入的 breadcrumb
      Sentry.addBreadcrumb({
        message: 'User logged in',
        category: 'auth',
        level: 'info',
        data: {
          empId: user.empId,
          empName: user.empName
        }
      });

      // 將用戶數據轉換為 JSON 格式並存儲在本地存儲中
      const userData = {
        username: this.username,
        empId: this.empId,
        empName: this.empName,
        taskCount: this.taskCount
      };

      // 將權限等級存儲在本地存儲中
      localStorage.setItem('user', JSON.stringify(userData));
    },

    clearUserData() {
      // 清除用戶資訊
      this.username = '';
      this.empId = '';
      this.empName = '';
      this.taskCount = 0;

      // 清除 Sentry 用戶資訊
      Sentry.setUser(null);

      // 添加用戶登出的 breadcrumb
      Sentry.addBreadcrumb({
        message: 'User logged out',
        category: 'auth',
        level: 'info'
      });

      // 清除本地存儲
      localStorage.removeItem('user');
    }
  }
});
